<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('meter_appinfo')">{{ $t('导出') }}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a>{{ $t('删除') }}</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <meter-appinfo-modal ref="modalForm" @ok="modalFormOk"></meter-appinfo-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import {isUndefined} from'@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterAppinfoModal from './modules/MeterAppinfoModal'
  import {netTypeObj} from '@/utils/constants/protocolConstant'

  export default {
    name: 'MeterAppinfoList',
    mixins:[JeecgListMixin],
    components: {
      MeterAppinfoModal
    },
    data () {
      return {
        description: 'meter_appinfo管理页面',
        url: {
          list: "/jeecg-charge/meter/meterAppinfo/list",
          delete: "/jeecg-charge/meter/meterAppinfo/delete",
          deleteBatch: "/jeecg-charge/meter/meterAppinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterAppinfo/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterAppinfo/importExcel",
          // importExcelUrl: "/meter/meterBatchTaskRecord/batchAddMeterByExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('平台类型'),
            align:"center",
            dataIndex: 'platformType',
            customRender:(t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            }
          },{
            title: this.$t('应用名称'),
            align:"center",
            dataIndex: 'appName'
          },
          {
            title: this.$t('激活状态'),
            align:"center",
            dataIndex: 'appActive'
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('修改人'),
            align:"center",
            dataIndex: 'updateBy'
          },{
            title: this.$t('修改时间'),
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>